import { t } from '@lingui/core/macro'
import ECharts from '~/components/echarts'
import ReactController from '~/controllers/react_controller'
import { awsEC2SbuUtilizationMonthlyChartPath } from '~/routes'

export default class AWSEC2SbuUtilizationMonthlyChartController extends ReactController {
  static values = {
    organizationId: String,
  }

  createComponent() {
    const url = awsEC2SbuUtilizationMonthlyChartPath(this.organizationIdValue)

    return (
      <ECharts
        title={t`Monthly SBU Utilization`}
        chartInfoTitle='aws_ec2_sbu_utilization_monthly'
        url={url}
        params={{}}
        showExportButton
      />
    )
  }
}
